import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { formatHeat } from "@/utils/format";

export default function FocusSection() {
  const featured = articles.filter((item) => item.featured);
  const main = featured[0];
  const side = featured[1];
  const rest = articles.filter((item) => !item.featured).slice(0, 5);

  return (
    <section id="focus" className="scroll-mt-40">
      <SectionHeading
        eyebrow="今日焦点"
        title="今天最值得跟进的几条线"
        desc="把当天讨论量最高的话题挑出来，先看焦点，再顺着时间线看细节。"
        moreText="进入每日合集"
        morePath="/daily"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <article className="group lg:col-span-2">
          <Link
            to={`/article/${main.slug}`}
            className="flex h-full flex-col overflow-hidden rounded-card border border-background-200/80 bg-background-50 transition-colors duration-200 hover:border-primary-200"
          >
            <div className="relative h-64 w-full overflow-hidden bg-background-200 md:h-80">
              <img
                src={main.cover}
                alt={main.coverAlt}
                title={main.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-fire-fill text-[12px]"></i>
                </span>
                今日第一
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-800">
                  {main.category}
                </span>
                <span>{main.date}</span>
                <span>{main.readTime}</span>
                <span className="flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-fire-line text-[12px] text-primary-500"></i>
                  </span>
                  {formatHeat(main.heat)}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700 md:text-2xl">
                {main.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{main.excerpt}</p>
              <ul className="mt-5 flex flex-col gap-2">
                {main.keyPoints.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </Link>
        </article>

        <div className="flex flex-col gap-6">
          <article className="group">
            <Link
              to={`/article/${side.slug}`}
              className="flex flex-col overflow-hidden rounded-card border border-background-200/80 bg-accent-50 transition-colors duration-200 hover:border-accent-300"
            >
              <div className="h-40 w-full overflow-hidden bg-background-200">
                <img
                  src={side.cover}
                  alt={side.coverAlt}
                  title={side.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-medium text-accent-950">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-movie-2-line text-[12px]"></i>
                  </span>
                  {side.category}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700">
                  {side.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {side.excerpt}
                </p>
              </div>
            </Link>
          </article>

          <div className="flex-1 rounded-card border border-background-200/80 bg-background-100/70 p-4">
            <h3 className="px-2 font-heading text-sm font-bold text-foreground-950">正在升温</h3>
            <div className="mt-2 flex flex-col">
              {rest.map((item) => (
                <ArticleCard key={item.slug} article={item} variant="compact" showCategory={false} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}